/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import requireAuth from "components/hoc/requireAuth";
import { getTrainingRequests } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import TrainingRequests from "components/trainingRequests/TrainingRequests";

class TrainingRequestsContainer extends Component {
  state = {
    dataFetched: false,
    trainingRequests: [],
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) { }

  fetchData = () => {
    this.props.getTrainingRequests(this.onBegin, this.onSuccess, this.onError);
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = (res) => {
    this.props.onProcessEnd();
    this.setState({
      dataFetched: true,
      trainingRequests: res.trainingRequests,
    });
  };

  renderTabbedContent = () => {
    if (!this.state.dataFetched) {
      return null;
    }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <TrainingRequests data={this.state.trainingRequests} />
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Talep Edilen Eğitimlerim">10569</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Talep Edilen Eğitimlerim">10569</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    application: state.application
  };
};

export default connect(mapStateToProps, {
  getTrainingRequests,
})(requireAuth(containsLongRunningProcess(TrainingRequestsContainer)));
